import HomePage from "./HomePage";
import "./index.css";
function App() {
  return <HomePage />;
}

export default App;
